/* global $ */

import React, { Component } from 'react';
import ReactHighcharts from 'react-highcharts';
import {LanguageSwitcher} from './LanguageSwitcher';
import {FAQLink} from './FAQLink';
import { config } from '../config.js';

export class Tabs extends Component {
    constructor(props) {
        super(props);
        this.previousRequest = undefined;
    }

    componentDidMount() {
        $('.tabular .item').tab();
        this.showDay();
    }

    render() {
        return(
            <div id="rangeTabs" className="ui fixed tabular menu">
                <span id="rangeLabel">{this.props.showMessage('message_1_01')}</span>
                <a id="day" className="active item first" onClick={this.showDay.bind(this)}>{this.props.showMessage('message_1_02')}</a>
                <a id="week" className="item" onClick={this.showWeek.bind(this)}>{this.props.showMessage('message_1_03')}</a>
                <a id="month" className="item" onClick={this.showMonth.bind(this)}>{this.props.showMessage('message_1_04')}</a>
                <div id="rightMenu">
                    {/*<FAQLink showFAQ={this.props.showFAQ} />*/}
                    <LanguageSwitcher changeLang={this.props.changeLang} lang={this.props.lang} />
                </div>
            </div>
        );
    }

    loadAnalyticsData(timePeriod) {
        var self = this;
        this.props.clearAnalyticsValues();
        var token = this.props.accessToken;
        var vRadiusServerId = this.props.vRadiusServerId;

        if (typeof this.previousRequest !== 'undefined') {
            this.previousRequest.abort();
            this.previousRequest = undefined;
            this.props.hideLoader();
        }

        this.props.showLoader();
        this.previousRequest = $.ajax({
        url: config.analyticsServiceUrl + '/data?time-period=' + timePeriod + '&start-date=&end-date=&servers=' + vRadiusServerId + 
            '&reports=totalSessions,totalSubscribers,totalNewSubscribers,authorizationsByDevice,sessionsTimeSeries,' +
            'bytesDownloadedTimeSeries,bytesUploadedTimeSeries,newSubscribersTimeSeries,' +
            'returningSubscribersTimeSeries,deviceFormats',
        method: 'GET',
        dataType: 'json',
        crossDomain: true,
        cache: false,
        beforeSend: function(request) {
            request.setRequestHeader("Authorization", "Bearer " + token);
        },
        success: function(data) {
            self.props.updateAnalyticsValues({
                'timePeriod': timePeriod,
                'totalSubscribers': data['totalSubscribers'],
                'totalNewSubscribers': data['totalNewSubscribers'],
                'returningSubscribers': data['totalSubscribers'] - data['totalNewSubscribers'],
                'operatingSystemData': [
                    data['authorizationsByDevice']['apple-ios'],
                    data['authorizationsByDevice']['android'],
                    data['authorizationsByDevice']['windows'],
                    data['authorizationsByDevice']['blackberry'],
                    data['authorizationsByDevice']['other']
                ],
                'downloadAndUploadTimeSeries': {
                    download: Object.keys(data['bytesDownloadedTimeSeries']).map(function(key) {
                        return [Number(key), data['bytesDownloadedTimeSeries'][key]];
                    }),
                    upload: Object.keys(data['bytesUploadedTimeSeries']).map(function(key) {
                        return [Number(key), data['bytesUploadedTimeSeries'][key]];
                    })
                },
                'newAndReturningSubscribersTimeSeries': {
                    new: Object.keys(data['newSubscribersTimeSeries']).map(function(key) {
                        return [Number(key), data['newSubscribersTimeSeries'][key]];
                    }),
                    returning: Object.keys(data['returningSubscribersTimeSeries']).map(function(key) {
                        return [Number(key), data['returningSubscribersTimeSeries'][key]];
                    })
                },
                'sessionsTimeSeries': Object.keys(data['sessionsTimeSeries']).map(function(key) {
                    return [Number(key), data['sessionsTimeSeries'][key]];
                }),
                'deviceFormats': [
                    {name:self.props.showMessage('message_1_05'), y: data['deviceFormats']['Phone']},
                    {name:self.props.showMessage('message_1_06'), y: data['deviceFormats']['Tablet']},
                    {name:self.props.showMessage('message_1_07'), y: data['deviceFormats']['Other']}
                ],
                'timePeriod': timePeriod
            });
            self.props.hideLoader();
        },
        error: function(xhr, status, err) {
            console.error(self.props.url, status, err.toString());
            self.props.hideLoader();
            if (xhr.status === 401) {
                self.props.showLogin();
            }
        }
        });
    }

    showDay() {
        this.dropTabStyles();
        $('#day').addClass('active');

        this.loadAnalyticsData('last-24-hours');
    }

    showWeek() {
        this.dropTabStyles();
        $('#week').addClass('active');

        this.loadAnalyticsData('last-week');
    }

    showMonth() {
        this.dropTabStyles();
        $('#month').addClass('active');

        this.loadAnalyticsData('last-month');
    }

    dropTabStyles() {
        $('#day').removeClass('active');
        $('#week').removeClass('active');
        $('#month').removeClass('active');
    };
};


// WEBPACK FOOTER //
// ./src/components/Tabs.jsx